import { format } from "date-fns";
import { RESPONSIBILITY_TYPES } from "../../../../utilities/dictionaryConstants";
import i18n from "../../../../utilities/i18n";
import { getStorage } from "../../../../utilities/browserStorage";
import { DEFAULT_PAGING_SIZE } from "../../../../utilities/staticConfigs";

/**
 * THis function used to validation process when we submit patient payment or insurance payment
 * @param {*} data 
 * @returns 
 */
export const postPaymentValidations = (data) => {
    let isError = false;
    let errorMessage = "";
    let status = "";
    if (!data.insurancePaymentVariables.payer || data.insurancePaymentVariables.payer == '' || data.insurancePaymentVariables.payer == null) {
        isError = true;
        errorMessage = i18n.t('errorMessages.payer_error');
        status = "error";
        return { isError: isError, errorMessage: errorMessage, status: status };
    }

    if (data.insurancePaymentVariables.level_adjustments > 0 &&
        data.insurancePaymentVariables.adjustment_type.length == 0) {
        isError = true;
        errorMessage = "Please select adjustment type"
        status = "error";
        return { isError: isError, errorMessage: errorMessage, status: status };
    }

    return { isError: isError, errorMessage: errorMessage, status: status }
}


export const postDatagenerator = (data) => {
    return {
        reference_check_number:
            data.insurancePaymentVariables["reference_check_number"],
    }
}

export const createJsonDataPatientPayment = (data) => {
    const groupedData = data.reduce((acc, current) => {
        let { id, claim_id, custom_claim_id, charges, receipts, opening_balance, apply_payment, apply_adjustments, dos_from, dos_to, save_procedure_id } = current;
        if (!acc[custom_claim_id]) {
            acc[custom_claim_id] = {
                custom_claim_id,
                claim_id,
                procedures: [],
                duplicate_procedures: [],
                id,
                dos_from,
                dos_to,
                edited: false,
                totalAdjustments: 0,
                totalCharges: 0,
                totalBalances: 0,
                totalReceiptAmount: 0,
                totalClosingBalance: 0,
                totalApplyAmount: 0
            };
        }

        let dateValues = {
            ...current,
            apply_payment: apply_payment ? apply_payment : 0,
            apply_adjustments: apply_adjustments ? apply_adjustments : 0,
            closing_balance: (parseFloat(opening_balance) || 0) -
            (parseFloat(apply_payment) || 0) -
            (parseFloat(apply_adjustments) || 0),
            save_procedure_id: save_procedure_id ? save_procedure_id : "",
        }

        acc[custom_claim_id].procedures.push(dateValues);
        acc[custom_claim_id].duplicate_procedures.push(dateValues);
        acc[custom_claim_id].totalCharges += parseFloat(charges ?? 0);
        acc[custom_claim_id].totalAdjustments += parseFloat(apply_adjustments ? apply_adjustments : 0);
        acc[custom_claim_id].totalApplyAmount += parseFloat(apply_payment ? apply_payment : 0);
        acc[custom_claim_id].totalBalances += parseFloat(opening_balance ?? 0);
        acc[custom_claim_id].totalReceiptAmount += parseFloat(receipts ?? 0);
        acc[custom_claim_id].totalClosingBalance =
            (parseFloat(acc[custom_claim_id].totalClosingBalance) || 0) +
            (parseFloat(opening_balance) || 0) -
            (parseFloat(apply_payment) || 0) -
            (parseFloat(apply_adjustments) || 0);
        return acc;
    }, {})

    return groupedData;
}

/**
 * This function will call when ever we click a custome claim id in insurance
 * it will format the procedures under a custome claim id to json data and display that to modal window
 * @param {*} data 
 * @returns 
 */
export const createProcedureData = (data, claimPaymentInfoId) => {
    let jsonObject = {};
    let oldResponsibilityObject = {};
    let responsibility_type = {};
    if (data.length > 0) {
        data.map((item, index) => {
            let adjustment_code1_data = [];
            let adjustment_code2_data = [];
            let remark_code = [];
            if (item.adjustment_1 && item.adjustment_1.length > 0) {
                for (var code1 in item.adjustment_1) {
                    const code1Data = {
                        amount:item.adjustment_1[code1].amount ?? 0,
                        code:item.adjustment_1[code1].code,
                        id:item.adjustment_1[code1].id,
                        label:item.adjustment_1[code1].label,
                        dropdown_name: item.adjustment_1[code1].label
                    }
                    adjustment_code1_data.push(code1Data)
                }
            }

            if (item.adjustment_2 && item.adjustment_2.length > 0) {
                for (var code2 in item.adjustment_2) {
                    const code2Data = {
                        amount:item.adjustment_2[code2].amount ?? 0,
                        code:item.adjustment_2[code2].code,
                        id:item.adjustment_2[code2].id,
                        label:item.adjustment_2[code2].label,
                        dropdown_name: item.adjustment_2[code2].label
                    }
                    adjustment_code2_data.push(code2Data)
                }
            }
            if (item.remark_code) {
                remark_code = item.remark_code;
            }
            let indexData = {
                claim: item.claim_id,
                procedure: item.procedure,
                allowed_amount: item.allowed_amount ?? 0,
                paid_amount: item.paid_amount ?? 0,
                receipts: item.receipts ? item.receipts : 0,
                custom_claim_id: item.custom_claim_id,
                dos_from: item.dos_from ? item.dos_from : "",
                remark_code: remark_code,
                opening_balance: item.balance ?? 0,
                closing_balance: item.closing_balance ?? 0,
                patient_id: item.patient_id ? item.patient_id : "",
                charges: item.charges ?? 0,
                copay: item.copay ?? 0,
                co_insurance: item.co_insurance ?? 0,
                deductibles: item.deductibles ?? 0,
                adjustment_code1_data: adjustment_code1_data,
                adjustment_code2_data: adjustment_code2_data,
                responsibility_type: item.responsibility_type,
                pay_procedure_status: item.pay_procedure_status ? item.pay_procedure_status : 0,
                entry_reversed: item.entry_reversed ? item.entry_reversed : false,
                reversed: item.reversed ? item.reversed : false,
                id: item.id ?? "",
                responsibility_list: item.responsibility_list && item.responsibility_list.length > 0 ? item.responsibility_list : RESPONSIBILITY_TYPES,
                claim_status_id: item.claim_status_id,
                claim_sub_status_id: item.claim_sub_status_id,
                previous_responsibility_type: item.previous_responsibility_type ? item.previous_responsibility_type : "",
                previous_claim_status_id: item.previous_claim_status_id ? item.previous_claim_status_id : "",
                previous_claim_sub_status_id: item.previous_claim_sub_status_id ? item.previous_claim_sub_status_id : "",
                moved_to_credit: item.moved_to_credit ? item.moved_to_credit : false,
                paid_by_entity: item.paid_by_entity ? item.paid_by_entity : 1,
                enable_moved_to_credit:enableMovedToCredit(item.paid_by_entity ?? 1,item.is_primary_paid ,item.is_secondary_paid,item.is_tertiary_paid ),
                is_first_payment: item.is_first_payment ? item.is_first_payment : false,
                is_primary_paid: item.is_primary_paid ? item.is_primary_paid : false,
                is_secondary_paid: item.is_secondary_paid ? item.is_secondary_paid : false,
                is_tertiary_paid: item.is_tertiary_paid ? item.is_tertiary_paid : false,
                isSkelton:false,
                skeltonId: "",
                claimPaymentInfoId: claimPaymentInfoId
            };

            if (item.save_procedure_id) {
                indexData = {
                    ...indexData,
                    save_procedure_id: item.save_procedure_id
                }
            }

            if (item.selected_remark_codes) {
                indexData = {
                    ...indexData,
                    selectedRemarkCodes: item.selected_remark_codes,
                }
            }
            jsonObject[`New-${crypto?.randomUUID()}`] = indexData;
            oldResponsibilityObject[index] = item.responsibility_type;
            responsibility_type[index] = item.responsibility_type;
        })
        return { jsonObject, oldResponsibilityObject, responsibility_type };
    } 

    // Ensure it always returns something
    return { jsonObject: {}, oldResponsibilityObject: [], responsibility_type: [] };
}




/**
 * This function will call when ever we click a custome claim id in patient payment
 * it will format the procedures under a custome claim id to json data and display that to modal window
 * @param {*} data 
 * @returns 
 */
export const createPatientProcedureData = (data) => {
    let jsonObject = {};
    if (data.procedures.length > 0) {
        data.procedures.map((item) => {
            jsonObject[`New-${crypto?.randomUUID()}`] = item;
        })

        return jsonObject;
    }
}

/**
 * This function is used to format reverse data in insurance payment
 * Here we do all changes for the reverse payment such as negative value convertion
 * We create a new entry for the reverse data here
 * @param {*} data 
 * @param {*} index 
 * @param {*} procedureData 
 * @param {*} id 
 * @returns 
 */
export const createReverseData = (data, index) => {
    try{
    let revexIndex = index + 1
    let adjustment1 = [];
    let adjustment2 = [];
    if (data.adjustment_code1_data && data.adjustment_code1_data.length > 0) {
        for (let code1 in data.adjustment_code1_data) {
            const code1Data = {
                ...data.adjustment_code1_data[code1],
                amount: data.adjustment_code1_data[code1].amount * -1
            }
            adjustment1.push(code1Data);
        }
    }
    if (data.adjustment_code2_data && data.adjustment_code2_data.length > 0) {
        for (let code1 in data.adjustment_code2_data) {
            const code1Data = {
                ...data.adjustment_code2_data[code1],
                amount: data.adjustment_code2_data[code1].amount * -1
            }
            adjustment2.push(code1Data);
        }
    }

    let editedData = {
        "payment": data.payment,
        "claim": data.claim,
        "procedure": data.procedure,
        "dos_from": data.dos_from,
        "custom_claim_id": data.custom_claim_id,
        "allowed_amount": data.allowed_amount ? data.allowed_amount * -1 : "0.00",
        "paid_amount": data.paid_amount ? data.paid_amount * -1 : "0.00",
        "remark_code": data.remark_code,
        "opening_balance": data.closing_balance ?? "0.00",
        "closing_balance": data.opening_balance ?? "0.00",
        "charges": data.charges ? data.charges * -1 : "0.00",
        "adjustment_code1_data": adjustment1,
        "adjustment_code2_data": adjustment2,
        "copay": data.copay ? data.copay * -1 : "0.00",
        "co_insurance": data.co_insurance ? data.co_insurance * -1 : "0.00",
        "deductibles": data.deductibles ? data.deductibles * -1 : "0.00",
        "pay_procedure_status": 1,
        "selectedRemarkCodes": data.selectedRemarkCodes,
        "id": data.id,
        "entry_reversed": true,
        "reversed": true,
        "receipts": data.receipts ? data.receipts * -1 : "0.00",
        "responsibility_list": data.responsibility_list ? data.responsibility_list : RESPONSIBILITY_TYPES,
        "moved_to_credit": data.moved_to_credit,
        "paid_by_entity": data.paid_by_entity
    }

    editedData = {
        [`New-${crypto?.randomUUID()}`]: {
            ...editedData,
            "responsibility_type": data.previous_responsibility_type ? data.previous_responsibility_type : "",
            "claim_status_id": data.previous_claim_status_id ? data.previous_claim_status_id : "",
            "claim_sub_status_id": data.previous_claim_sub_status_id ? data.previous_claim_sub_status_id : "",
        }
    }

    return {editedData,revexIndex}
    }catch(error){
        console.error(error)
    }
}

export function decimalConverter(value) {
    const parsedValue = parseFloat(value);
    return isNaN(parsedValue) ? 0 : parsedValue;
}

/**
 * insert responsibility to reversIndex position
 * @param {*} responsibility_type 
 * @param {*} index 
 * @param {*} value 
 * @returns 
 */
export const insertAtPosition = (responsibility_type, index, value) => {
    const data = { ...responsibility_type };
    const keysToShift = Object.keys(data)
        .map(k => parseInt(k))
        .filter(k => !isNaN(k) && k >= index)
        .sort((a, b) => b - a);

    keysToShift.forEach(k => {
        const currentValue = data[k];
        if (currentValue !== undefined) {
            data[(k + 1).toString()] = currentValue;
        }
    });

    data[index] = value;

    return data
};

/**
 * This function is used to identify the changes maded in insurance payment on blurer
 * It is used to change the responsibility and claim status and claim sub status also closing balance
 * @param {*} data 
 * @param {*} field 
 * @param {*} oldResponsibility 
 * @param {*} responsibility_type 
 * @returns 
 */
export const checkForDataChanges = (data, field, oldResponsibility, responsibility_type) => {
    const paymentPostStatus = Boolean(data["save_procedure_id"]);
    const paid_amount = decimalConverter(data["paid_amount"]);
    const allowed_amount = decimalConverter(data["allowed_amount"]);
    const opening_balance = decimalConverter(data["opening_balance"]);
    const totalAdjustment1Amount = decimalConverter(data.adjustment_code1_data?.reduce((total, item) => total + (Number(item?.amount) || 0), 0));

    const closing_balance = Number((opening_balance - paid_amount - totalAdjustment1Amount).toFixed(2));
    const hasAdjustmentCode2 = data["adjustment_code2_data"]?.length > 0;
    const adjustmentCodeExists = checkAdjustmentCode(data["adjustment_code2_data"]);

    const isAllowedAmountPaid = paid_amount === allowed_amount && allowed_amount !== 0;
    const isClosingBalanceZero = closing_balance <= 0;

    const resolveResponsibility = () => {
        if (hasAdjustmentCode2) {
            return adjustmentCodeExists ? findResponsibilityByID(data, oldResponsibility) : handleResponsibilityType(data, responsibility_type, oldResponsibility, opening_balance);
        }
        return oldResponsibility;
    };

    if (!paymentPostStatus) {
        switch (field) {
            case "allowed_amount":
                if (isAllowedAmountPaid) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                return { responsibilityID: resolveResponsibility(), closing_balance };

            case "paid_amount":
                if (isAllowedAmountPaid && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                if (!hasAdjustmentCode2 && isClosingBalanceZero) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                return { responsibilityID: resolveResponsibility(), closing_balance };

            case "adjustment_amount1":
            case "adjustment_code1_data":
                if (isAllowedAmountPaid && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                if (!hasAdjustmentCode2 && isClosingBalanceZero) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                return { responsibilityID: resolveResponsibility(), closing_balance };

            case "adjustment_amount2":
            case "adjustment_code2_data":
                if (!hasAdjustmentCode2 && isClosingBalanceZero) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                if (isAllowedAmountPaid && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                return { responsibilityID: resolveResponsibility(), closing_balance };
        }
    } else {
        switch (field) {
            case "paid_amount":
                if (isAllowedAmountPaid && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                }
                else if (!hasAdjustmentCode2 && isClosingBalanceZero) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                } else if (data["adjustment_code2_data"].length > 0) {
                    const exist = checkAdjustmentCode(data["adjustment_code2_data"]);
                    if (exist) {
                        return { responsibilityID: findResponsibilityByID(data, data["previous_responsibility_type"]), closing_balance }
                    }
                    else {
                        return { responsibilityID: handleResponsibilityType(data, data["previous_responsibility_type"], oldResponsibility, opening_balance), closing_balance }
                    }
                } else if (!isClosingBalanceZero && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByID(data, data["previous_responsibility_type"]), closing_balance }
                }
                return { responsibilityID: data["previous_responsibility_type"], closing_balance };
            case "adjustment_amount1":
            case "adjustment_code1_data":
                if (!hasAdjustmentCode2 && isClosingBalanceZero) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                } else if (isAllowedAmountPaid && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                } else if (data["adjustment_code2_data"].length > 0) {
                    const exist = checkAdjustmentCode(data["adjustment_code2_data"]);
                    if (exist) {
                        return { responsibilityID: findResponsibilityByID(data, data["previous_responsibility_type"]), closing_balance }
                    }
                    else {
                        return { responsibilityID: handleResponsibilityType(data, data["previous_responsibility_type"], oldResponsibility, opening_balance), closing_balance }
                    }
                } else if (!isClosingBalanceZero && !hasAdjustmentCode2) {
                    return { responsibilityID: findResponsibilityByID(data, data["previous_responsibility_type"]), closing_balance }
                }
                return { responsibilityID: data["previous_responsibility_type"], closing_balance };
            case "adjustment_amount2":
            case "adjustment_code2_data":
                if (data["adjustment_code2_data"].length > 0) {
                    if (data["previous_responsibility_type"] !== oldResponsibility) {
                        const exist = checkAdjustmentCode(data["adjustment_code2_data"]);
                        if (exist) {
                            return { responsibilityID: findResponsibilityByID(data, data["previous_responsibility_type"]), closing_balance }
                        }
                        else {
                            return { responsibilityID: handleResponsibilityType(data, data["previous_responsibility_type"], oldResponsibility, opening_balance), closing_balance }
                        }
                    } else {
                        const exist = checkAdjustmentCode(data["adjustment_code2_data"]);
                        if (exist) {
                            return { responsibilityID: findResponsibilityByID(data, data["previous_responsibility_type"]), closing_balance }
                        }
                        else {
                            return { responsibilityID: handleResponsibilityType(data, data["previous_responsibility_type"], oldResponsibility, opening_balance), closing_balance }
                        }
                    }
                } else {
                    if (isAllowedAmountPaid) {
                        return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                    } else if (isClosingBalanceZero) {
                        return { responsibilityID: findResponsibilityByName(data, 'Paid'), closing_balance };
                    }
                    else {
                        return { responsibilityID: data["previous_responsibility_type"], closing_balance };
                    }
                }
        }
    }
    return { responsibilityID: oldResponsibility, closing_balance };
};


export function checkAdjustmentCode(procedure) {
    let allowedLabels = ["PR-1", "PR-2", "PR-3"];
    let adjustmentCodes = procedure;
    let length = adjustmentCodes.length;

    if (adjustmentCodes && Array.isArray(adjustmentCodes)) {
        // Iterate over the adjustmentCodes array in reverse to safely splice
        for (let i = adjustmentCodes.length - 1; i >= 0; i--) {
            if (allowedLabels.includes(adjustmentCodes[i].label)) {
                length--;
            }
        }
    }
    if (length == 0) {
        return false;
    } else {
        return true;
    }
}


export function checkAdjustmentCodeDenialId(procedure) {
    const allowedLabels = ["PR-1", "PR-2", "PR-3"];
    let filteredItems = procedure.filter(item => !allowedLabels.includes(item.label));

    // If no items match, return null
    if (filteredItems.length === 0) return null;

    // Get the last item from filtered list and return its claim_sub_status id
    const lastItem = filteredItems[filteredItems.length - 1];

    return lastItem.claim_sub_status?.length > 0
        ? lastItem.claim_sub_status[0]?.id
        : "";
}

const findResponsibilityByName = (data, name) => {
    return data["responsibility_list"]?.find(item => item.name === name)?.id;
};

const findResponsibilityByID = (data, id) => {
    return data["responsibility_list"]?.find(item => item.id === id)?.id;
};

const handleResponsibilityType = (data, responsibility_type, oldResponsibility, opening_balance) => {
    switch (responsibility_type) {
        case 1: // Secondary
            return findResponsibilityByName(data, 'Secondary') || findResponsibilityByName(data, 'Patient');
        case 2: // Tertiary
            return findResponsibilityByName(data, 'Tertiary') || findResponsibilityByName(data, 'Patient');
        case 3: // Patient
        case 4:
            return findResponsibilityByName(data, 'Patient');
        case 5: // Special case
            return opening_balance <= 0 ? 5 : (findResponsibilityByName(data, 'Secondary') || findResponsibilityByName(data, 'Patient'));
        default:
            return oldResponsibility;
    }
};


/**
 * This function is used for identify errors in insuranc payment procedure level for all fields
 * @param {*} data 
 * @param {*} procedureError 
 * @returns 
 */
export const checkForErrors = (data, procedureError) => {

    let errors = { ...procedureError };
    let paid_amount = Number(Number(data.paid_amount)?.toFixed(2)) || 0;
    let charges = Number(Number(data.charges)?.toFixed(2)) || 0;
    let allowed_amount = Number(Number(data.allowed_amount)?.toFixed(2)) || 0;
    let discount = charges - allowed_amount;
    let opening_balance = Number(Number(data.opening_balance)?.toFixed(2)) || 0;
    let totalAdjustment1Amount = data.adjustment_code1_data?.reduce((sum, adjustmentItem) => {
        // CON-253 Should not be considered as discount
        if (adjustmentItem.label?.toLowerCase() !== "co-253") {
            return sum + Number(adjustmentItem?.amount);
        } else {
            return sum;
        }
    }, 0) || 0;


    let totalAdjustmentAmount2 = data.adjustment_code2_data?.reduce((sum, adjustmentItem) => sum + Number(adjustmentItem?.amount), 0) || 0;

    if (allowed_amount > opening_balance) {
        errors["allowed_amount"] = 'Allowed amount cannot be greater than opening balance amount.';
    } else {
        if (errors && Object.prototype.hasOwnProperty.call(errors, 'allowed_amount')) {
            delete errors.allowed_amount;
        }
    }

    if (paid_amount > charges || paid_amount > allowed_amount) {
        errors["paid_amount"] = 'Paid amount cannot be greater than charges amount or allowed amount.';
    }
    else {
        if (errors && Object.prototype.hasOwnProperty.call(errors, 'paid_amount')) {
            delete errors.paid_amount;
        }
    }

    if (Number(Number(totalAdjustment1Amount)?.toFixed(2)) > Number(Number(discount)?.toFixed(2))) {
        errors["adjustment_amount1"] = {
            ...data.adjustment_code1_data.reduce((errors, adjustmentItem) => {
                if (adjustmentItem.label?.toLowerCase() !== "co-253") {
                    errors[adjustmentItem.id] = {
                        id: adjustmentItem.id,
                        message: 'Total Adjustment 1 amount should not be greater than Charge amount - Allowed amount.',
                        label: adjustmentItem?.label
                    };
                }
                return errors;

            }, {})
        }
    } else {
        if (errors["adjustment_amount1"]) {
            errors["adjustment_amount1"] = {
                ...data.adjustment_code1_data.reduce((errors, adjustmentItem) => {
                    if (adjustmentItem.label?.toLowerCase() !== "co-253") {
                        delete errors[adjustmentItem.id]
                    }
                    return errors;

                }, {})
            }
        }
    }

    if (Number(Number(totalAdjustmentAmount2)?.toFixed(2)) > Number((allowed_amount - paid_amount)?.toFixed(2))) {
        errors["adjustment_amount2"] = {
            ...data.adjustment_code2_data.reduce((errors, adjustmentItem) => {
                errors[adjustmentItem.id] = {
                    id: adjustmentItem.id,
                    message: 'Total Adjustment 2 amount should not be greater than Allowed amount - Paid amount.',
                    label: adjustmentItem?.label
                };
                return errors;
            }, {})
        }
    } else {
        if (errors["adjustment_amount2"]) {
            errors["adjustment_amount2"] = {
                ...data.adjustment_code2_data.reduce((errors, adjustmentItem) => {
                    delete errors[adjustmentItem.id]
                    return errors;
                }, {})
            }
        }
    }
    return errors;
}

/**
 * function is used to create form data for patient procedure level save functionality
 * @param {*} patientClaims 
 * @returns 
 */
export const generatePatientSaveData = async (patientClaims) => {
    let saveData = [];
    Object.keys(patientClaims).forEach(ele1 => {
        let item = patientClaims[ele1];
        if (item.procedures.length > 0) {
            item.procedures.forEach(ele2 => {
                let data = {
                    apply_payment: ele2.apply_payment === "" ? "0.00" : ele2.apply_payment,
                    "apply_adjustments": ele2.apply_adjustments === "" ? "0.00" : ele2.apply_adjustments,
                    "claim": ele2.claim_id,
                    "procedure": ele2.id ? ele2.id : ele2.procedure_id ? ele2.procedure_id : "",
                    "opening_balance": ele2.opening_balance,
                    "closing_balance": ele2.closing_balance,
                    "responsibility_type": ele2.responsibility_type,
                    "claim_status_id": ele2.claim_status_id,
                    "claim_sub_status_id": ele2.claim_sub_status_id,
                    "save_procedure_id": ele2.save_procedure_id ? ele2.save_procedure_id : ''
                }
                saveData.push(data);
            })
        }
    })

    return saveData;
}


/**
 * function is used to create form data for insurance procedure level save functionality
 * @param {*} claimListData 
 * @param {*} insurancePaymentData 
 * @returns 
 */
export const generateSaveProcedureData = (procedureData,reverseStatus=false) => {
    let saveData = [];
    Object.keys(procedureData).forEach(ele1 => {
        let item = procedureData[ele1];
        let adjustment1_data = [];
        let adjustment2_data = [];
        if (item.adjustment_code1_data && item.adjustment_code1_data.length > 0) {
            for (var code1 in item.adjustment_code1_data) {
                const code1Data = {
                    code: item.adjustment_code1_data[code1].label,
                    amount: parseFloat(item.adjustment_code1_data[code1].amount),
                    id: item.adjustment_code1_data[code1].id
                }
                adjustment1_data.push(code1Data)
            }
        }

        if (item.adjustment_code2_data && item.adjustment_code2_data.length > 0) {
            for (var code2 in item.adjustment_code2_data) {
                const code1Data = {
                    code: item.adjustment_code2_data[code2].label,
                    amount: parseFloat(item.adjustment_code2_data[code2].amount),
                    id: item.adjustment_code2_data[code2].id
                }
                adjustment2_data.push(code1Data)
            }
        }

        let data = {
            ...item,
            copay: item.copay && item.copay != "" ? item.copay : 0.00,
            co_insurance: item.co_insurance && item.co_insurance != "" ? item.co_insurance : 0.00,
            deductibles: item.deductibles && item.deductibles != "" ? item.deductibles : 0.00,
            allowed_amount: item.allowed_amount ? item.allowed_amount : 0.00,
            paid_amount: item.paid_amount ? item.paid_amount : 0.00,
            procedure: item.id ?? "",
            adjustments: {
                adjustment1: adjustment1_data,
                adjustment2: adjustment2_data,
            },
        }
        delete data["custom_claim_id"];
        delete data["id"];
        delete data["receipts"];
        delete data["responsibility_list"];
        delete data["dos_from"];
        delete data["patient_id"];
        delete data["adjustment_1"];
        delete data["adjustment_2"];
        delete data["previous_responsibility_type"];
        delete data["previous_claim_status_id"];
        delete data["previous_claim_sub_status_id"];
        delete data["balance"];
        delete data["responsibility_type_name"];
        delete data["selected_remark_codes"];
        delete data["claim_id"];
        delete data["reversed"];
        delete data["claim"];
        delete data["closing_balance"];
        delete data["charges"];
        delete data["selectedRemarkCodes"];
        delete data["custom_patient_id"];
        delete data["is_first_payment"];
        delete data["is_primary_paid"];
        delete data["is_secondary_paid"];
        delete data["is_tertiary_paid"];
        delete data["adjustment_code1_data"];
        delete data["adjustment_code2_data"];
        delete data["claim"];
        delete data["isSkelton"];
        delete data["skeltonId"];
        delete data["enable_moved_to_credit"];
        if(reverseStatus){
            delete data["save_procedure_id"]
        }
        saveData.push(data);
    })

    return saveData;

}

/**
 * This function validate patient level data errors on save of that payment 
 * @param {*} patientClaims 
 * @returns 
 */
export const checkForValidationErrorPatient = (patientClaims) => {
    let validationError = [];
    let isError = false;

    Object.keys(patientClaims).forEach((item) => {
        let procedureData = patientClaims[item].procedures;
        procedureData.forEach((item, index) => {
            if (item?.responsibility_type == null) {
                validationError.push({
                    error: i18n.t(
                        "payments.post_payments.insurancePayment.paymenMessages.emptyPaymentResponsibleType"
                    ) + ` ${item.custom_claim_id} procedure line ${index + 1}`
                })
            }
        })
    })

    if (validationError.length > 0) {
        isError = true;
    }
    else {
        isError = false;
    }
    return { isError, validationError };
}

/**
 * This function validate insurance level data errors on save of that payment 
 * @param {*} claimList 
 * @param {*} insurancePaymentData 
 * @returns 
 */
export const checkForValidationError = (procedureData, insurancePaymentData,data) => {
    let validationError = [];
    let isError = false;
    const dataValues = Object.values(data);
    Object.keys(procedureData).forEach((key) => {

        let item = procedureData[key];
        const position = dataValues.findIndex(originalItem => originalItem.id === item.id);

        let paid_amount = parseFloat(item.paid_amount);
        let allowed_amount = parseFloat(item.allowed_amount);
        let copay = parseFloat(item.copay ? item.copay : 0);
        let co_insurance = parseFloat(item.co_insurance ? item.co_insurance : 0);
        let deductibles = parseFloat(item.deductibles ? item.deductibles : 0);

        let amount1 = parseFloat(allowed_amount - paid_amount);

        let amount2 = deductibles + co_insurance + copay;

        if (item?.responsibility_type == null) {
            validationError.push({
                error: i18n.t(
                    "payments.post_payments.insurancePayment.paymenMessages.emptyPaymentResponsibleType"
                ) + ` ${item.custom_claim_id} procedure line ${position+1}`
            })
        }

        const date1 = new Date(insurancePaymentData.payment_date);
        const date2 = new Date(item.dos_from);
        const isDate2GreaterThanDate1 = date2 < date1;
        if (!isDate2GreaterThanDate1) {
            validationError.push({
                error: i18n.t(
                    "payments.post_payments.insurancePayment.paymenMessages.paymentDateAlert"
                ) + ` ${item.custom_claim_id} procedure line`
            })
        }

        if (parseFloat(amount2.toFixed(2)) > parseFloat(amount1.toFixed(2)) && amount1 != 0 && !item?.reversed) {
            validationError.push({
                error: i18n.t(
                    "payments.post_payments.insurancePayment.paymenMessages.copayValidation"
                ) + `${item.custom_claim_id} procedure line`
            })

        }

        if (parseFloat(item.paid_amount) > 0 && parseFloat(item.allowed_amount) > 0) {
            if (
                parseFloat(item.paid_amount) > parseFloat(item.allowed_amount)) {
                validationError.push({
                    error: i18n.t(
                        "payments.post_payments.insurancePayment.paymenMessages.paidAmountValidation"
                    ) + ` ${item.custom_claim_id} procedure line`
                })
            }
        }

        if (!item.paid_by_entity) {
            validationError.push({
                error: i18n.t(
                    "payments.post_payments.insurancePayment.paymenMessages.emptyPaidByEntity"
                ) + ` ${item.custom_claim_id} procedure line ${position+1}`
            })
        }
    })


    if (validationError.length > 0) {
        isError = true;
    }
    else {
        isError = false;
    }
    return { isError, validationError };
}

/**
 * This function will trigger when ever we click on the modal save button
 * Here we will store the new value to the main patientClaim redux state and update it 
 * @param {*} data 
 * @returns 
 */
export const generateTablePatientData = (data) => {
    let totalChargeEdited = 0;
    let totalReceiptEdited = 0;
    let totalBalanceEdited = 0;
    let totalAdjustmentsEdited = 0;
    let totalApplyAmount = 0;
    let totalClosingBalanceEdited = 0;
    let procedures = [];
    Object.keys(data).forEach((current) => {
        const { apply_payment, apply_adjustments, opening_balance, charges, receipts } = data[current];
        let closing_balance =
            (parseFloat(opening_balance) || 0) -
            (parseFloat(apply_payment) || 0) -
            (parseFloat(apply_adjustments) || 0);
        totalChargeEdited += parseFloat(charges ?? 0);
        totalReceiptEdited += parseFloat(receipts ?? 0);
        totalBalanceEdited += parseFloat(opening_balance ?? 0);
        totalAdjustmentsEdited += parseFloat(apply_adjustments ?? 0);
        totalApplyAmount += parseFloat(apply_payment ?? 0);
        totalClosingBalanceEdited += parseFloat(closing_balance ?? 0);
        procedures.push(data[current])
    }, {});
    return {
        totalChargeEdited, totalReceiptEdited, totalBalanceEdited, totalAdjustmentsEdited, totalApplyAmount, totalClosingBalanceEdited, procedures
    };
}

export const formatDate = (date) => {
    return date instanceof Date ? format(date, "yyyy-MM-dd") : "";
};


export const getSumAppliedUnApplied = (data, patientDetails, action) => {
  const amount = Number(data.amount ?? 0);

  if (action === "get") {
    const balanceAmount = Number(data.balance_amount ?? 0);
    const sumApplied = amount - balanceAmount;
    return {
      unApplied: amount - sumApplied,
      sumApplied,
      alreadyApplied: sumApplied,
    };
  }

  if (action === "edit") {
    const sumApplied = Number(patientDetails.sumApplied ?? 0);
    return {
      unApplied: amount - sumApplied,
      sumApplied,
      alreadyApplied: sumApplied,
    };
  }

  return { unApplied: 0, sumApplied: 0, alreadyApplied: 0 };
};


export function isValidDate(dateString) {
    const dateObject = new Date(dateString);
    return dateObject instanceof Date && !isNaN(dateObject);
}


export const sortByDate = (sortOrder, obj) => {
    const claimsArray = Object.values(obj);
    claimsArray.sort((a, b) => {
        const dateA = new Date(a.dos_from);
        const dateB = new Date(b.dos_from);

        return sortOrder === "balanceUnderPatientNewestFirst"
            ? dateB - dateA
            : dateA - dateB;
    });

    // Return sorted claim IDs
    return claimsArray.map(item => item.custom_claim_id);
};

export function getChangedClaims(original, updated) {
    const numericFields = [
        'allowed_amount', 'paid_amount', 'charges', 'copay',
        'co_insurance', 'deductibles', 'receipts', 'opening_balance', 'closing_balance'
    ];

    const normalizeValue = (key, val) => {
        if (numericFields.includes(key) && typeof val === 'string' && !isNaN(val)) {
            return parseFloat(val);
        }
        return val;
    };

    const isObject = val => val && typeof val === 'object' && !Array.isArray(val);
    const isArray = Array.isArray;

    const deepEqual = (a, b) => {
        const isNumeric = (val) => !isNaN(val) && !isNaN(parseFloat(val));

        if (isNumeric(a) && isNumeric(b)) {
            return parseFloat(a) === parseFloat(b);
        }

        if (a === b) return true;

        if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
                return false;
            }
        }

        return true;
    };

    const arraysEqual = (arr1 = [], arr2 = []) => {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((item, index) => deepEqual(item, arr2[index]));
    };

    const isDifferent = (a, b, key = '') => {
        const valA = normalizeValue(key, a);
        const valB = normalizeValue(key, b);

        if (isArray(valA) && isArray(valB)) {
            return !arraysEqual(valA, valB);
        } else if (isObject(valA) && isObject(valB)) {
            const keys = new Set([...Object.keys(valA), ...Object.keys(valB)]);
            for (let k of keys) {
                if (isDifferent(valA[k], valB[k], k)) return true;
            }
            return false;
        } else {
            return valA !== valB;
        }
    };

    const jsonObject = {};

    for (const key in updated) {
        const updatedEntry = updated[key];
        const originalEntry = original[key];
        // Case 2: Entry has entry_reversed_action: true → skip
        if ((originalEntry.pay_procedure_status ?? 0)==1 && (originalEntry?.entry_reversed??false)) {
            continue;
        }

        // Case 3: Entry is different → add to result
        if (isDifferent(originalEntry, updatedEntry) && updatedEntry.save_procedure_id) {
            jsonObject[`New-${crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`] = updatedEntry;
        }
    }

    return jsonObject;
}


export const getInterCPTDatas = (updated) => {

    const jsonObject = {};
    for (const key in updated) {
        const updatedEntry = updated[key];
        // Case 2: Entry has entry_reversed_action: true → skip
        if (!updatedEntry?.save_procedure_id) {
            jsonObject[`New-${crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`] = updatedEntry;
        }

    }

    return jsonObject;
}


/**reverser request builder */
export const buildReverseRequestData = (payment_pk, claim_pk, save_procedure_id, procedures_data, claimPaymentInfoIdOpened) => ({
    current_practice_id: getStorage("practice"),
    payment_pk,
    claim_pk,
    save_procedure_id,
    procedures_data,
    claim_payment_info_id: claimPaymentInfoIdOpened
});

//** insurance-payment save and update request builder*/
export const buildPayloadData = (
    payload,
    insurancePaymentData,
    claimPK,
    saveData,
    interCptSaveData,
    isNewClaim,
    claimPaymentInfoId
) => {
    let requestBody;
    if (isNewClaim) {
        requestBody = {
            current_practice_id: getStorage("practice"),
            payment_pk: insurancePaymentData?.id || payload.pk,
            claim_pk: claimPK,
            procedures_data: saveData
        }
    }else{
        requestBody = {
            current_practice_id: getStorage("practice"),
            payment_pk: insurancePaymentData?.id || payload.pk,
            claim_pk: claimPK,
            procedures_data:interCptSaveData,
            old_procedures_data: saveData,
            claim_payment_info_id: claimPaymentInfoId
        } 
    }

    return requestBody;
}

//**Error handler for insurance-payment save and update */
export const handleAPIError = (response,) => {
  const msg = response?.data?.message;
  const errorMsg = response?.data?.error_message;

  const messageMap = {
    "invalid_responsibility_type": `Claim status selected not matching with the Priority on Procedure ${response?.result?.data?.cpt ?? ""}`,
    "cpt_or_claim_status_missing": i18n.t("payments.post_payments.insurancePayment.paymenMessages.procedureOrClaimStatusMissing"),
    "paid_amount_not_tally_with_check": i18n.t("payments.post_payments.insurancePayment.paymenMessages.paidAmountNotification"),
    "payment_object_not_found": i18n.t("payments.post_payments.insurancePayment.paymenMessages.paymentObjectNotFound"),
    "procedure_not_found": i18n.t("payments.post_payments.insurancePayment.paymenMessages.ProcedureNotFound"),
    "claim_not_found": i18n.t("payments.post_payments.insurancePayment.paymenMessages.claimNotFound"),
    "claim_already_exists": i18n.t("payments.post_payments.insurancePayment.paymenMessages.claimAlreadyExist")
  };

  const notifyMessage = messageMap[msg] || msg || errorMsg || "An error occurred";
  return { message: notifyMessage, statusTag: "error" };
};


// Helper: Validate date filters
export const validateDateFilters = (filters) => {
    const { payment_date_from, payment_date_to, payment_entered_date_from, payment_entered_date_to } = filters;

    if (payment_date_to && payment_date_from && new Date(payment_date_to) < new Date(payment_date_from)) {
        return { message: i18n.t("commons.dateOrder"), tag: "error" };
    }

    if (payment_entered_date_to && payment_entered_date_from && new Date(payment_entered_date_to) < new Date(payment_entered_date_from)) {
        return { message: i18n.t("commons.dateOrder"), tag: "error" };
    }

    return null;
};

// Helper: Build query string from filters
export const buildQueryString = (filters, selectedPatient, activePage) => {
    const practice_pk = getStorage("practice");
    let query = `?practice_pk=${practice_pk}&page_size=${DEFAULT_PAGING_SIZE}&page=${activePage}`;

    const mapField = (key, value) => {
        if (!value || (Array.isArray(value) && value.length === 0)) return '';
        if (value instanceof Date) {
            return `&${key}=${format(value, 'yyyy-MM-dd')}`;
        }
        return `&${key}=${encodeURIComponent(value)}`;
    };

    const fields = {
        payment_from: filters.payment_from,
        patient_pk: selectedPatient,
        insurance: filters.insurance,
        reference_check_number: filters.reference_check_number,
        payment_date_from: filters.payment_date_from,
        payment_date_to: filters.payment_date_to,
        entered_date_from: filters.payment_entered_date_from,
        entered_date_to: filters.payment_entered_date_to,
        provider_pk: filters.provider,
        cpt_pk: filters.hcpcs,
        revenue_pk: filters.revenue_codes,
        icd: filters.icd,
    };

    Object.entries(fields).forEach(([key, val]) => {
        query += mapField(key, val);
    });

    return query;
};


/**
 * this function check the condition to enable or disable moved to credit 
 * @param {*} paid_by_entity 
 * @param {*} paid_status 
 */
export const enableMovedToCredit = (
    paid_by_entity,
    is_primary_paid = false,
    is_secondary_paid = false,
    is_tertiary_paid = false
) => {
    const paidStatus = {
        1: is_primary_paid,
        2: is_secondary_paid,
        3: is_tertiary_paid,
    };

    return Boolean(paidStatus[paid_by_entity]);
};